export default "__VITE_ASSET__z7TlIa6d__"